// @mui
import { createTheme } from "@mui/material/styles";
import { Breakpoints } from "./Breakpoints";
import { getPalette } from "./Palette";
import { getShadows } from "./Shadows";
const breakpoints = Breakpoints.breakpoints;
export const getThemeBase = (mode = "light") => {
  const palette = getPalette(mode).palette;
  const shadows = getShadows(mode).shadows;
  return createTheme({
    breakpoints,
    spacing: 8,
    palette,
    shadows
  });
};